import {useLegacyGrpcRequest} from '@aboutyou/data-fetcher';
import {useUserToken} from '../userStore/user.selector';
import {Customer_getCustomer} from '@aboutyou/grpc-clients/grips/protos/deprecated/customer.grpc';
import {CustomerResponse} from '@aboutyou/grpc-clients/grips/protos/deprecated/customer.types';
import {CustomerV1_hasValidToken} from '@aboutyou/grpc-clients/grips/protos/customer/customer_v1.grpc';
import {createDataStore} from '../createDataStore';

const useExpensiveCustomerResponse = () => {
  const authToken = useUserToken();

  return useLegacyGrpcRequest(
    Customer_getCustomer,
    {
      session: {
        authToken: authToken!,
      },
    },
    {
      disabled: !authToken,
      keepPreviousData: false,
    },
  );
};

const {Provider, useData: useCustomerResponse} = createDataStore<
  CustomerResponse | undefined
>({
  defaultValue: undefined,
  useQueryHook: useExpensiveCustomerResponse,
});

export {Provider as CustomerProvider, useCustomerResponse};

/**
 * Validates current logged-in user's accessToken
 */
export const useValidateUserToken = () => {
  const authToken = useUserToken();

  return useLegacyGrpcRequest(CustomerV1_hasValidToken, {
    session: {authToken: authToken!},
  });
};
